// extracted by mini-css-extract-plugin
export var claims = "claims__i0A2";
export var counter = "counter__ia21";
export var counterHeader = "counter-header__bKwJ";
export var header = "header__OU1k";
export var passport = "passport__G79o";
export var recs = "recs__kzec";